import { FEngineException, fe$utils } from './v2-fgen-fengine.js';
window.applyCSS05 = () => {

    // Default classes 
    document.querySelectorAll('.FE-controlR').forEach(ctrl => ctrl.classList.add('form__input', 'form-group'));
    document.querySelectorAll('.FE-controlR-label').forEach(ctrl => ctrl.classList.add('form__label'));
    document.querySelectorAll('.FE-controlR-control').forEach(ctrl => ctrl.classList.add('form-control'));

    //Checkbox
    document.querySelectorAll('.FE-check').forEach(ctrl => {
        ctrl.classList.remove('form__input');
        ctrl.classList.add('form__checkbox', 'form-group', 'align-items-start');
    });

    document.querySelectorAll('.FE-checkR-control,.FE-invitation-sessioncontrol').forEach(ctrl => {
        ctrl.classList.remove('form-control');
        ctrl.classList.add('form-checkbox');
    });
    document.querySelectorAll('.FE-checkR-label').forEach(ctrl => {
        ctrl.classList.add('form__checklabel');
    });



    // Choice Styrdio
    document.querySelectorAll('.FE-styrdiochoiceR-control').forEach(ctrl => ctrl.classList.remove('form-control'));

    //Choice
    document.querySelectorAll('.FE-controlR.FE-choice').forEach(ctrl => ctrl.classList.add('formselectwrap', 'form__dropdown-desktop'));
    document.querySelectorAll('.FE-controlR-control.FE-choiceR-control').forEach(ctrl => {
        ctrl.classList.remove('form-control');
        ctrl.classList.add('select-selected');
        ctrl.addEventListener('click', e => {
            e.currentTarget.classList.toggle('select-arrow-active');
            e.currentTarget.nextSibling.classList.toggle('select-hide');
            e.currentTarget.nextSibling.style.height = 'auto';
        });
        ctrl.style.margin = '0';

    });
    document.querySelectorAll('.FE-choice .FE-choiceR-options').forEach(ctrl => {
        ctrl.classList.add('select-items', 'select-hide');
        ctrl.addEventListener('click', e => {
            e.currentTarget.classList.add('select-hide');
            e.currentTarget.previousSibling.classList.remove('select-arrow-active');
        });
    });

    document.querySelectorAll('.FE-choiceR-options.select-items').forEach(ctrl => {
        ctrl.style.top = '';
    });


    //MultiChoice
    document.querySelectorAll('.FE-controlR.FE-multichoice').forEach(ctrl => ctrl.classList.add('formselectwrap', 'form__dropdown-desktop'));
    document.querySelectorAll('.FE-controlR-control.FE-multichoiceR-control').forEach(ctrl => {
        ctrl.classList.remove('form-control');
        ctrl.classList.add('select-selected');
        ctrl.addEventListener('click', e => {
            e.currentTarget.classList.toggle('select-arrow-active');
            e.currentTarget.nextSibling.classList.toggle('select-hide');
            e.currentTarget.nextSibling.style.height = 'auto';
        });
        ctrl.addEventListener('mouseleave', e => {
            e.currentTarget.classList.remove('select-arrow-active');
            e.currentTarget.nextSibling.classList.add('select-hide');
            e.currentTarget.nextSibling.style.height = 'auto';
        });
        ctrl.style.margin = '0';

    });
    document.querySelectorAll('.FE-multichoice .FE-multichoiceR-options').forEach(ctrl => {
        ctrl.classList.add('select-items', 'select-hide');
        ctrl.addEventListener('click', e => {
            e.currentTarget.classList.add('select-hide');
            e.currentTarget.previousSibling.classList.remove('select-arrow-active');
        });
    });

    document.querySelectorAll('.FE-multichoiceR-options.select-items').forEach(ctrl => {
        ctrl.style.top = '';
    });

    document.querySelectorAll('.FE-multichoiceR-check').forEach(ctrl => {
        ctrl.classList.add('form-checkbox');
    });

    //MultiLevelChoice
    document.querySelectorAll('.FE-controlR.FE-multilevelchoice').forEach(ctrl => ctrl.classList.remove('form__input'));

    //Title and subtitle 
    document.querySelectorAll('.banner__title .form__label').forEach(ctrl => ctrl.classList.remove('form__label'));
    document.querySelectorAll('.banner__subtitle .form__label').forEach(ctrl => ctrl.classList.remove('form__label'));
    document.querySelectorAll('.form__title .form__label').forEach(ctrl => ctrl.classList.remove('form__label'));
    document.querySelectorAll('.form__subtitle .form__label').forEach(ctrl => ctrl.classList.remove('form__label'));


    //Submit Button and others Buttons
    document.querySelectorAll('.FE-submit-raw input,.FE-button-raw input').forEach(ctrl => ctrl.classList.add('input-submit', 'form__btn', 'btn'));
}

function fet$unexpectedError(message) {
    console.log('Unexpected error occurred: ' + message);
    toggleError(true, message);
}

function fet$showSubmitSuccess() {
    console.log('[t_CBaW] Showing success');
    document.querySelector(".form__wrapper.form").style.display = 'none';
    document.querySelector(".form__wrapper.thanks").style.display = 'block';
    document.querySelector("#thanks").style.display = 'block';
}

function fet$redirect(url) {
    console.log('[t_CBaW] Redirecting to ' + url);
    window.location.assign(url);
}

function fet$showSubmitError(errorMessage) {
    console.log('Obtained server response: ' + errorMessage);
    fe$utils.removeClass('submitting', document.getElementById('form'));
    document.getElementById('progress').style.display = 'none';
    toggleError(true, errorMessage); // This one does not show text
    document.getElementById('errors').scrollIntoView();
}

function fet$onSubmit() { //fe$utils.addClass('submitting', document.getElementById('form')); 
}

function fea$acceptSuccess() { fet$acceptSuccess(); }

function fet$showForm() {
    document.getElementById('form').style.display = 'block';
    document.getElementById('unrecoverable').style.display = 'none';
    document.getElementById('thanks').style.display = 'none';
}

function fet$acceptSuccess() { 
    console.log('Success accepted');
    if(!window.history.back())
        window.close()
}

function fet$showLangs() {
    document.querySelectorAll(".cmp-lang-items").forEach(e => e.classList.remove('select-hide'));
    document.querySelectorAll(".cmp-lang-selected").forEach(e => e.classList.add('select-arrow-active'));
}

function fet$hideLangs(lang) {
    document.querySelectorAll(".cmp-lang-items").forEach(e => e.classList.add('select-hide'));
    document.querySelectorAll(".cmp-lang-selected").forEach(e => {
        e.innerHTML = lang.toUpperCase();
        e.classList.remove('select-arrow-active');
    });
}

/* Callback to inform langs available for configuration */
function fet$langsAvailable(langs, defLang) {

    Array.from(document.getElementsByClassName("cmp-lang-items"))
        .forEach(select => {
            langs.forEach(lang => {
                const oLang = document.createElement('div');
                const oText = document.createTextNode(lang.toUpperCase());
                oLang.appendChild(oText);
                oLang.addEventListener('click', e => {
                    fe$ngine.setLanguage(lang);
                    fet$hideLangs(lang);
                    fet$renderFooter(lang);
                });
                select.appendChild(oLang);
            });
        });

    Array.from(document.getElementsByClassName("cmp-lang-selected"))
        .forEach(o => {
            o.innerHTML = defLang.toUpperCase();
            o.addEventListener('click', e => fet$showLangs());
        });
}

function fet$renderFooter(lang) {

    /* TODO: Se ha de revisar con el nuevo footer de OAC

    const hcfooter =  new FE$HardcodedFooterRenderer();
    
function fet$renderFooter = lang => {

    const hcfooter = new FE$HardcodedFooterRenderer();

    const legal = document.querySelector(".ft-legal");
    legal.href = hcfooter._i18n.legallink[lang];
    legal.innerHTML = hcfooter._i18n.legal[lang];

    const cookies = document.querySelector(".ft-cookies");
    cookies.href = hcfooter._i18n.cookieslink[lang];
    cookies.innerHTML = hcfooter._i18n.cookies[lang];

    const mgcookies = document.querySelector(".ft-cookies-manager");
    mgcookies.innerHTML = hcfooter._i18n.cookiescfg[lang];

    const atencio = document.querySelector(".ft-atencio");
    atencio.href = hcfooter._i18n.maillink[lang];
    atencio.innerHTML = hcfooter._i18n.mail[lang];

    const logo = document.querySelector(".ft-logo");
    logo.src = hcfooter._i18n.imagesrc[lang];

    const cr = document.querySelector(".ft-copyright");
    cr.innerHTML = hcfooter._i18n.copyright[lang];
    */
}

function fet$onRendering(inprogress) {
    console.log('Rendering? ' + inprogress)
    if (inprogress) {

        let uri = fe$ngine.getBackground();
        if (uri) {
            document.querySelector(".banner").style.backgroundImage = `url(${uri})`;
        }

    } else {

        var logoNode = document.getElementById('logo');
        if (!logoNode.hasChildNodes()) {
            fe$utils.addClass('nologo', document.body)
        } else {
            console.log('[PG] Has logo');
        }
        applyCSS05();
    }
}

function fet$onProgress(amount, message) {
    console.log('[TPL] Progress: ' + amount + ' - ' + message);

    var bar = document.getElementById('progress-content');
    if (amount > 0 && bar.style.width == '100%') {
        console.log('[TPL] Progress: filtering old calls ');
        return;
    }

    var ctr = document.getElementById('progress');
    ctr.style.display = 'block';

    var progress = Math.floor(amount * 1000) / 10;

    bar.style.width = progress + '%';
    console.log('[TPL] Set bar to: ' + bar.style.width);
    var msg = document.getElementById('progress-message');
    while (msg.hasChildNodes()) {
        msg.removeChild(msg.childNodes[0]);
    }
    msg.appendChild(document.createTextNode(message));

    var progressLbl = document.getElementById('progress-labelout');
    while (progressLbl.hasChildNodes()) {
        progressLbl.removeChild(progressLbl.firstChild);
    }
    progressLbl.appendChild(document.createTextNode(progress + '%'));
    if (amount == 1) {
        setTimeout(function () {
            ctr.style.display = 'none';
        }, 500);
    }

}

function toggleError(visible, message) {
    document.getElementById('errors').style.display = (visible ? 'block' : 'none');
    document.getElementById('genericError').style.display = (message ? 'none' : 'block');
    var errSpec = document.getElementById('specificError');
    errSpec.style.display = (message ? 'block' : 'none');
    if (message) {
        while (errSpec.hasChildNodes()) {
            errSpec.removeChild(errSpec.firstChild);
        }
        errSpec.appendChild(document.createTextNode(message));
        document.getElementById('errors').scrollIntoView();
    }

    if (visible) {
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        })
    }
}

function fet$onValidationPerformed(success, errors) {
    console.log('Validation detected with errors: ' + JSON.stringify(errors));
    //toggleError(!success); // This one does not show text
    toggleError(!success, errors ? errors.global : undefined);
}

function fet$onUnrecoverableError(code, message) {
    document.getElementById('form').style.display = 'none';
    document.getElementById('unrecoverable').style.display = 'block';
    document.getElementById('progress').style.display = 'none';

    var msgEl = document.getElementById('unrecoverable-message');
    while (msgEl.hasChildNodes()) {
        msgEl.removeChild(msgEl.firstChild);
    }
    msgEl.appendChild(document.createTextNode(message));

}

function onLangChanged(lang) {
    console.log('Lang changed to: ' + lang);
    for (var k in langNodes) {
        if (k == lang) {
            langNodes[k].setAttribute('class', 'lang selected');
        } else {
            langNodes[k].setAttribute('class', 'lang');
        }
    }
    fe$ngine.setLanguage(lang);
}
if (!window.lang) {
    window.lang = 'es';
}

export {
    fet$unexpectedError, fet$showSubmitSuccess, fet$redirect,
    fet$showSubmitError, fet$onSubmit, fet$langsAvailable,
    fet$onRendering, fet$onProgress, onLangChanged, toggleError,
    fet$onValidationPerformed, fet$onUnrecoverableError,
    fea$acceptSuccess
}